import {
  createUser,
  CreateUserMutation,
  CreateUserMutationVariables,
  deleteUser,
  DeleteUserMutation,
  DeleteUserMutationVariables,
  graphqlCall,
  updateUser,
  UpdateUserMutation,
  UpdateUserMutationVariables,
} from '@akin-home/amplify';

export const updateUserMutation = (params: UpdateUserMutationVariables) =>
  graphqlCall<UpdateUserMutation>(updateUser, params);

export const createUserMutation = (params: CreateUserMutationVariables) =>
  graphqlCall<CreateUserMutation>(createUser, params);

export const deleteUserMutation = (params: DeleteUserMutationVariables) =>
  graphqlCall<DeleteUserMutation>(deleteUser, params);
